const FloralBorder = ({ children }) => {
  const s_line_h = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='10'%3E%3Cpath d='M0 5 C 10 0, 10 10, 20 5 S 30 0, 40 5' stroke='%23896f3d' stroke-opacity='0.6' fill='none' stroke-width='1.5'/%3E%3C/svg%3E";
  const s_line_v = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='40'%3E%3Cpath d='M5 0 C 0 10, 10 10, 5 20 S 0 30, 5 40' stroke='%23896f3d' stroke-opacity='0.6' fill='none' stroke-width='1.5'/%3E%3C/svg%3E";

  return (
    <div className="relative">
      {/* Lines */}
      <div className="absolute top-0 left-0 right-0 h-[10px]" style={{ backgroundImage: `url("${s_line_h}")` }} />
      <div className="absolute bottom-0 left-0 right-0 h-[10px]" style={{ backgroundImage: `url("${s_line_h}")` }} />
      <div className="absolute top-0 bottom-0 left-0 w-[10px]" style={{ backgroundImage: `url("${s_line_v}")` }} />
      <div className="absolute top-0 bottom-0 right-0 w-[10px]" style={{ backgroundImage: `url("${s_line_v}")` }} />
      
      <div className="relative z-10 p-12 text-center">
        {children}
      </div>
    </div>
  );
};

export default FloralBorder; 